import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("hg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Noget gik galt. Prøv igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Public
export const getCases = () => client.get("/cases").then((r) => r.data);
export const getCase = (slug) => client.get(`/cases/${slug}`).then((r) => r.data);
export const getContent = () => client.get("/content").then((r) => r.data);
export const submitLead = (payload) => client.post("/leads", payload).then((r) => r.data);

// Auth
export const login = (email, password) =>
  client.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);

// Admin
export const adminCases = () => client.get("/admin/cases").then((r) => r.data);
export const adminCreateCase = (data) => client.post("/admin/cases", data).then((r) => r.data);
export const adminUpdateCase = (id, data) => client.put(`/admin/cases/${id}`, data).then((r) => r.data);
export const adminDeleteCase = (id) => client.delete(`/admin/cases/${id}`).then((r) => r.data);
export const adminLeads = () => client.get("/admin/leads").then((r) => r.data);
export const adminUpdateLead = (id, status) => client.patch(`/admin/leads/${id}`, { status }).then((r) => r.data);
export const adminDeleteLead = (id) => client.delete(`/admin/leads/${id}`).then((r) => r.data);
export const adminUpdateContent = (key, value) => client.put(`/admin/content/${key}`, { value }).then((r) => r.data);

export default client;
